export function openUrl() {
   const url = `https://wa.me/5571996204608?text=Olá,%20tudo%20bem?%20Vi%20o%20site%20https://www.fonotherapp.com.br/%20e%20gostaria%20de%20saber%20sobre%20a%20consultoria.%20Poderiam%20me%20enviar%20mais%20informações?`
   window.open(url, "_blank")
}
